import ApiService from "@/common/api/api.service";


const ProjetoRN219 = {
    
    salvar(form) {
        if(form.id)
            return ApiService.put(`ProjetoRN219`, form);
        return ApiService.post(`ProjetoRN219`, form);
    },

    listar(empresaId, tamanhoDaPagina = 0, numeroDaPagina = 0) {
        return ApiService.get(`ProjetoRN219?EmpresaId=${empresaId}&TamanhoDaPagina=${tamanhoDaPagina}&NumeroDaPagina=${numeroDaPagina}`);
    },

    buscar(id){
        return ApiService.get(`ProjetoRN219/${id}`);
    },

    salvarDesembolso(form) {
        if(form.id)
            return ApiService.put(`ProjetoRN219/desembolso`, form);
        return ApiService.post(`ProjetoRN219/desembolso`, form);
    },

    excluirDesembolso(id){
        return ApiService.delete(`ProjetoRN219/desembolso`, {id});
    },

    downloadDesembolso(id){
        return ApiService.downloadFile(`ProjetoRN219/desembolso/download-arquivo?id=${id}`);
    },

    salvarCusto(form) {
        if(form.id)
            return ApiService.put(`ProjetoRN219/custo-proprio`, form);
        return ApiService.post(`ProjetoRN219/custo-proprio`, form);
    },

    excluirCusto(id){
        return ApiService.delete(`ProjetoRN219/custo-proprio`, {id});
    },

    downloadCusto(id){
        return ApiService.downloadFile(`ProjetoRN219/custo-proprio/download-arquivo?id=${id}`);
    },

}

export default ProjetoRN219;
